module.exports = "<section>\n  <div class=\"logo-page-not-found\">\n    <img src=\"assets/images/logo.png\"/>\n    <h3 style=\"text-transform: uppercase;\">Oops... la page demandée n'est pas valide</h3>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = main